"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/BoxiStatus.css");
var _Icon_thermometre = _interopRequireDefault(require("../assets/Icon_thermometre.png"));
var _Icon_humidity = _interopRequireDefault(require("../assets/Icon_humidity.png"));
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _IconFailure = _interopRequireDefault(require("./IconFailure"));
var _GraphTemperature = _interopRequireDefault(require("./GraphTemperature"));
var _GraphHumidity = _interopRequireDefault(require("./GraphHumidity"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : BoxiStickStatus.js
* Description : Ce fichier contient la définition du composant BoxiStickStatus 
*               Ce composant affiche le status des capteurs d'un Boxistick 
* Date de création : 13 juin 2024
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* BoxiStickStatus : ce composant affiche le status des capteurs d'un Boxistick 
*
* Type : composant 
*
* Parametres : 
*  - ptu -- ptu du Boxistick
*  - date -- date des données capteur à afficher 
*/
function BoxiStickStatus(_ref) {
  var ptu = _ref.ptu,
    date = _ref.date;
  // Define useState hooks
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    Sensor1ModuleTemperatures = _useState2[0],
    setSensor1ModuleTemperatures = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    HIH6030ModuleTemperatures = _useState4[0],
    setHIH6030ModuleTemperatures = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    HIH6030ModuleHumidities = _useState6[0],
    setHIH6030ModuleHumidities = _useState6[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authToken = _useAuth.authToken;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Fonctions 
  var clickSensor1 = function clickSensor1(event) {
    event.preventDefault();
    setHIH6030ModuleTemperatures([]);
    setHIH6030ModuleHumidities([]);
    retrieveSensor1ModuleTemperatures(date);
  };
  var clickHIH6030Temp = function clickHIH6030Temp(event) {
    event.preventDefault();
    setSensor1ModuleTemperatures([]);
    setHIH6030ModuleHumidities([]);
    retrieveHIH6030ModuleTemperatures(date);
  };
  var clickHIH6030Humid = function clickHIH6030Humid(event) {
    event.preventDefault();
    setSensor1ModuleTemperatures([]);
    setHIH6030ModuleTemperatures([]);
    retrieveHIH6030ModuleHumidities(date);
  };
  function retrieveSensor1ModuleTemperatures(_x) {
    return _retrieveSensor1ModuleTemperatures.apply(this, arguments);
  }
  function _retrieveSensor1ModuleTemperatures() {
    _retrieveSensor1ModuleTemperatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(selectedDate) {
      var token, response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve equipment details
            _context.n = 1;
            return fetch(path + "/api/eq-smte/extract/?module_id=" + ptu['id'] + '&datetime=' + selectedDate, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            response = _context.v;
            _context.n = 2;
            return response.json();
          case 2:
            data = _context.v;
            setSensor1ModuleTemperatures(data);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveSensor1ModuleTemperatures.apply(this, arguments);
  }
  function retrieveHIH6030ModuleTemperatures(_x2) {
    return _retrieveHIH6030ModuleTemperatures.apply(this, arguments);
  }
  function _retrieveHIH6030ModuleTemperatures() {
    _retrieveHIH6030ModuleTemperatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(selectedDate) {
      var token, response, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve equipment details
            _context2.n = 1;
            return fetch(path + "/api/eq-hmte/extract/?module_id=" + ptu['id'] + '&datetime=' + selectedDate, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            response = _context2.v;
            _context2.n = 2;
            return response.json();
          case 2:
            data = _context2.v;
            setHIH6030ModuleTemperatures(data);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _retrieveHIH6030ModuleTemperatures.apply(this, arguments);
  }
  function retrieveHIH6030ModuleHumidities(_x3) {
    return _retrieveHIH6030ModuleHumidities.apply(this, arguments);
  }
  function _retrieveHIH6030ModuleHumidities() {
    _retrieveHIH6030ModuleHumidities = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(selectedDate) {
      var token, response, data;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve equipment details
            _context3.n = 1;
            return fetch(path + "/api/eq-hmhu/extract/?module_id=" + ptu['id'] + '&datetime=' + selectedDate, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            response = _context3.v;
            _context3.n = 2;
            return response.json();
          case 2:
            data = _context3.v;
            setHIH6030ModuleHumidities(data);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _retrieveHIH6030ModuleHumidities.apply(this, arguments);
  }
  var handleDateSelectionToCSV = function handleDateSelectionToCSV(event) {
    event.preventDefault();
    sendRequestToGenerateFile();
  };
  function sendRequestToGenerateFile(_x4) {
    return _sendRequestToGenerateFile.apply(this, arguments);
  } // Define useEffect hooks    
  function _sendRequestToGenerateFile() {
    _sendRequestToGenerateFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(filename) {
      var token, response, blob, url, link, filepath, _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Create and download csv file
            _context4.p = 1;
            _context4.n = 2;
            return fetch(path + "/api/eq-eqnt/" + ptu.equipment.id + "/boxistick-data/?datetime=" + date, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 2:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 3;
              break;
            }
            throw new Error('Erreur pendant le téléchargement');
          case 3:
            _context4.n = 4;
            return response.blob();
          case 4:
            blob = _context4.v;
            url = window.URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = url;
            filepath = 'sensors-data-boxistick-' + date + '.csv';
            link.download = filepath; // Nom du fichier proposé
            document.body.appendChild(link);
            link.click();

            // Nettoyage
            link.remove();
            window.URL.revokeObjectURL(url);
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t = _context4.v;
            console.error('Erreur = ', _t);
            alert('Impossible de télécharger le fichier');
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 5]]);
    }));
    return _sendRequestToGenerateFile.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (Sensor1ModuleTemperatures.length !== 0) {
      retrieveSensor1ModuleTemperatures(date);
    } else if (HIH6030ModuleTemperatures.length !== 0) {
      retrieveHIH6030ModuleTemperatures(date);
    } else if (HIH6030ModuleHumidities.length !== 0) {
      retrieveHIH6030ModuleHumidities(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  // Render component 
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "margin-bottom margin-top",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 800 ? 'flex-row justify-center margin-bottom margin-top' : 'flex-column justify-center margin-bottom margin-top',
      children: ptu !== null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "status-stick",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex-row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-empty-space"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            onClick: clickSensor1,
            className: "sensor-box-center flex-row clickable",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Icon_thermometre["default"],
              alt: "Icon_thermometre"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "text-box",
              children: "(S1) x\xB0C"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-empty-space"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex-row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-bar-empty-space"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "bar"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-bar-empty-space"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex-row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-bar-empty-space"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            onClick: clickHIH6030Temp,
            className: "sensor-box-left flex-row clickable",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Icon_thermometre["default"],
              alt: "Icon_thermometre"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "text-box",
              children: "(L) x\xB0C"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-center-empty-space"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            onClick: clickHIH6030Humid,
            className: "sensor-box-right flex-row clickable",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _Icon_humidity["default"],
              alt: "Icon_humidity"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "text-box",
              children: "(L) x%"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "box-bar-empty-space"
          })]
        })]
      }) : null
    }), Sensor1ModuleTemperatures && Sensor1ModuleTemperatures.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "title-table",
        children: "(S1) temperatures"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GraphTemperature["default"], {
        data: Sensor1ModuleTemperatures,
        limit_value: 55
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
        component: _Paper["default"],
        className: "margin-bottom margin-top table-border",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
          sx: {
            minWidth: 300
          },
          size: "small",
          "aria-label": "a dense table",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Datetime"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Temperature (\xB0C)"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Overtemp"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Failure"
                })
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
            children: Sensor1ModuleTemperatures.map(function (item) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                sx: {
                  '&:last-child td, &:last-child th': {
                    border: 0
                  }
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  component: "th",
                  scope: "row",
                  children: item['datetime']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: item['temperature']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['overtemp']
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['failure']
                  })
                })]
              }, item.id);
            })
          })]
        })
      })]
    }) : HIH6030ModuleTemperatures && HIH6030ModuleTemperatures.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "title-table",
        children: "(L) temperatures"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GraphTemperature["default"], {
        data: HIH6030ModuleTemperatures,
        limit_value: 55
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
        component: _Paper["default"],
        className: "margin-bottom margin-top table-border",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
          sx: {
            minWidth: 300
          },
          size: "small",
          "aria-label": "a dense table",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Datetime"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Temperature (\xB0C)"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Overtemp"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Failure"
                })
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
            children: HIH6030ModuleTemperatures.map(function (item) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                sx: {
                  '&:last-child td, &:last-child th': {
                    border: 0
                  }
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  component: "th",
                  scope: "row",
                  children: item['datetime']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: item['temperature']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['overtemp']
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['failure']
                  })
                })]
              }, item.id);
            })
          })]
        })
      })]
    }) : HIH6030ModuleHumidities && HIH6030ModuleHumidities.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "title-table",
        children: "(L) humidities "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GraphHumidity["default"], {
        data: HIH6030ModuleHumidities,
        limit_value: 90
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
        component: _Paper["default"],
        className: "margin-bottom margin-top table-border",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
          sx: {
            minWidth: 300
          },
          size: "small",
          "aria-label": "a dense table",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Datetime"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Humidit\xE9 (%)"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Over humidity"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "table-label",
                  children: "Failure"
                })
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
            children: HIH6030ModuleHumidities.map(function (item) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                sx: {
                  '&:last-child td, &:last-child th': {
                    border: 0
                  }
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  component: "th",
                  scope: "row",
                  children: item['datetime']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: item['humidity']
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['over_humidity']
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconFailure["default"], {
                    input: item['failure']
                  })
                })]
              }, item.id);
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "margin-top",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Aucune donn\xE9es disponibles concernant ce capteur pour le jour s\xE9lectionn\xE9e"
      })
    }), screenWidth > 410 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-row justify-center margin-top",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "title-table",
        children: "Sauvegarde CSV : "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: handleDateSelectionToCSV,
        className: "link link-border clickable",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "link-text",
          children: "Toutes les donn\xE9es"
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "margin-top",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "title-table",
        children: "Sauvegarde CSV : "
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: handleDateSelectionToCSV,
        className: "link link-border clickable",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "link-text",
          children: "Toutes les donn\xE9es"
        })
      })]
    })]
  });
}
var _default = exports["default"] = BoxiStickStatus;